import Inquiring from './Inquiring'

export default Inquiring
